import { APP_INITIALIZER, enableProdMode, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app/app-routing';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { ConfigService } from './app/shared/services/config.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NotificationToastrService } from './app/shared/services/notification-toastr.service';
import { NotificationService } from './app/shared/services/notification.service';
import { MessageService } from 'primeng/api';
import { provideRouter } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';

const appInitializerFn = (configService: ConfigService) => {
  return () => {
    return configService.setConfig();
  };
};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

if (environment.production) {
  enableProdMode();
}

const provideAppInitializer = () => {
  return {
    provide: APP_INITIALIZER,
    useFactory: appInitializerFn,
    multi: true,
    deps: [ConfigService],
  };
};

const dtgyPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#ECF1FE',
      100: '#D8E2FE',
      200: '#ABC3FD',
      300: '#7CA8FC',
      400: '#388EFA',
      500: '#1972D2',
      600: '#125CAB',
      700: '#0B4482',
      800: '#052E5B',
      900: '#021B3A',
      950: '#011128',
    },
  },
  components: {
    inputtext: {
      border: {
        color: '#53606e',
      },
      hover: {
        border: {
          color: '#53606e',
        },
      },
      disabled: {
        background: '#5d6e80',
        border: {
          color: '#5d6e80',
        },
        color: 'black',
      },
    },
    select: {
      border: {
        color: '#53606e',
      },
      hover: {
        border: {
          color: '#53606e',
        },
      },
    },
  },
});

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule),
    provideAppInitializer(),
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: NotificationService, useClass: NotificationToastrService },
    MessageService,
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideRouter(routes),
    providePrimeNG({
      theme: {
        preset: dtgyPreset,
        options: {
          darkModeSelector: false || 'none',
        },
      },
    }),
  ],
}).catch(err => console.error(err));
